export default __webpack_public_path__ + "static/media/rotate.02761356.svg";